class FormatNumberService {
  formatAsCurrency(amount: number) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    const value = Number(amount).toFixed();
    return formatter.format(Number(value));
  }

  formatAsCurrencyWithDecimal(amount: number, decimal: number) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal
    });
    return formatter.format(Number(amount));
  }

  formatNumberResult(amount: number) {
    if ((amount * 1) === 0) {
      return this.formatAsCurrency(0);
    }
    else {
      return amount > 0 ? this.formatAsCurrency(amount) : "(" + this.formatAsCurrency(Math.abs(amount)) + ")";
    }
  }

  formatNumberResultWithDecimal(amount: number, decimal: number) {
    if ((amount * 1) === 0) {
      return this.formatAsCurrencyWithDecimal(0, decimal);
    }
    else {
      return amount > 0 ? this.formatAsCurrencyWithDecimal(amount, decimal) : "(" + this.formatAsCurrencyWithDecimal(Math.abs(amount), decimal) + ")";
    }
  }

  formatNumberPercentage(amount: number) {
    if ((amount * 1) === 0) {
      return Number(0).toFixed() + "%";
    }
    else {
      return amount > 0 ? amount.toFixed() + "%" : "(" + Math.abs(Number(amount.toFixed())) + "%)";
    }
  }

  formatNumberPercentageWithDecimal(amount: number, decimal: number) {
    if ((amount * 1) === 0) {
      return Number(0).toFixed(decimal) + "%";
    }
    else {
      return amount > 0 ? amount.toFixed(decimal) + "%" : "(" + Math.abs(amount).toFixed(decimal) + "%)";
    }
  }
}

export default new FormatNumberService();
